import { useState } from "react"

export type AdminTableStatus = "all" | "enabled" | "disabled"
export type AdminTableSort =
  | "original"
  | "name-asc"
  | "name-desc"
  | "enabled-first"
  | "disabled-first"

export function useAdminTableControls<T>(
  rows: T[],
  {
    getName,
    getSearchText,
    isEnabled,
  }: {
    getName: (row: T) => string
    getSearchText: (row: T) => string
    isEnabled: (row: T) => boolean
  }
) {
  const [search, setSearch] = useState("")
  const [status, setStatus] = useState<AdminTableStatus>("all")
  const [sort, setSort] = useState<AdminTableSort>("original")
  const query = search.trim().toLocaleLowerCase()
  const filteredRows = rows.filter(
    (row) =>
      (!query || getSearchText(row).toLocaleLowerCase().includes(query)) &&
      (status === "all" || isEnabled(row) === (status === "enabled"))
  )
  if (sort !== "original") {
    filteredRows.sort((a, b) => {
      const names = getName(a).localeCompare(getName(b), undefined, {
        numeric: true,
        sensitivity: "base",
      })
      if (sort === "name-asc") return names
      if (sort === "name-desc") return -names
      const enabledOrder = Number(isEnabled(b)) - Number(isEnabled(a))
      return (sort === "enabled-first" ? enabledOrder : -enabledOrder) || names
    })
  }
  return {
    rows: filteredRows,
    search,
    setSearch,
    status,
    setStatus,
    sort,
    setSort,
    total: rows.length,
    count: filteredRows.length,
  }
}
